import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../../contexts/CartContext.jsx";
import "../../styles/default.css";
import io from "socket.io-client";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [hasNewOrders, setHasNewOrders] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const { itemCount } = useCart();

  useEffect(() => {
    // Load user data
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }

    // Initial check for new orders
    checkNewOrders();

    // Check every minute for new orders
    const interval = setInterval(checkNewOrders, 60000);

    // Setup socket connection
    const socket = io(`${import.meta.env.VITE_API_URL}`);

    socket.on("newProduct", (data) => {
      setNotifications((prev) => [
        ...prev,
        { id: Date.now(), message: data.message },
      ]);
    });

    socket.on("orderStatusUpdate", (data) => {
      setNotifications((prev) => [
        ...prev,
        { id: Date.now(), message: `Your command is now ${data.newStatus}` },
      ]);
    });

    return () => {
      clearInterval(interval);
      socket.disconnect();
    };
  }, []);

  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((note) => note.id !== id));
  };

  const checkNewOrders = async () => {
    if (!userData?.id) return; // Make sure we have a user ID

    try {
      const token = localStorage.getItem("clientToken");
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/commands`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch orders");

      const orders = await response.json();

      // Get the timestamp of last visit to orders page
      const lastVisit = localStorage.getItem("lastOrdersVisit") || "0";

      // Check if there are any orders newer than last visit
      const hasNew = orders.some((order) => {
        const orderDate = new Date(order.createdAt).getTime();
        return orderDate > parseInt(lastVisit);
      });

      setHasNewOrders(hasNew);
    } catch (error) {
      console.error("Error checking orders:", error);
    }
  };

  // Update last visit time when visiting the orders page
  useEffect(() => {
    if (location.pathname === "/my-orders") {
      localStorage.setItem("lastOrdersVisit", Date.now().toString());
      setHasNewOrders(false);
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("clientToken");
    localStorage.removeItem("userData");
    setUserData(null);
    navigate("/");
    window.location.reload();
  };

  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="headerCont">
      <div className="w-full flex items-center justify-between ">
        <div className="header_left">
          <div className="iblotec_logo">
            <img src="images/iblotec logo.png" alt="IBloTech Logo" />
          </div>
          <span className="iblotec_name head">
            <span className="iblo">IBlo</span> <span className="tec">Tec</span>
            {/* <h6>Client</h6> */}
          </span>
        </div>

        <div className="hidden md:flex">
          <nav className="flex w-fit h-full  items-center justify-center gap-10">
            <Link
              to="https://iblotecmarket.com/"
              className={`navItem ${isActive("/market") ? "navActive" : ""}`}
            >
              Market
            </Link>
            <Link
              to="/home"
              className={`navItem ${isActive("/home") ? "navActive" : ""}`}
            >
              About Us
            </Link>
            <a
              href="https://api.whatsapp.com/send?phone=+25769316827&text=Hello"
              target="_blank"
              rel="noopener noreferrer"
              className=""
              style={{ display: "flex", alignItems: "center", gap: "0.35rem" }}
            >
              <i className="fa-brands fa-whatsapp text-black hover:text-green-500 text-3xl"></i>
            </a>
          </nav>
        </div>

        <div className="header_right">
          <div className="flex items-center space-x-6">
            {/* <Link
              to="/cart"
              className="relative p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors group"
            >
              <i className="fa-solid fa-shopping-cart text-gray-700 group-hover:text-cyan-600 transition-colors"></i>
              {itemCount > 0 && (
                <span className="absolute -top-0 -right-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {itemCount}
                </span>
              )}
            </Link> */}

            {userData ? (
              <div className="relative">
                <div
                  className="w-10 h-10 rounded-full overflow-hidden cursor-pointer border-2 border-gray-200 hover:border-cyan-400 transition-colors"
                  onClick={toggleProfileMenu}
                >
                  <img
                    src={
                      userData.profilepicture
                        ? `${import.meta.env.VITE_API_URL}/${
                            userData.profilepicture
                          }`
                        : "images/default-profile.png"
                    }
                    alt="Profile"
                    className="w-full h-full object-cover"
                  />
                </div>
                {showProfileMenu && (
                  <div className="absolute top-full right-0 mt-2 bg-white rounded-2xl shadow-2xl border border-gray-200 p-2 min-w-48 z-10">
                    <Link
                      to="/profile"
                      className="w-full flex items-center space-x-3 px-4 py-3 text-left hover:bg-gray-50 rounded-xl transition-colors text-gray-700"
                      onClick={() => setShowProfileMenu(false)}
                    >
                      <i className="fa-solid fa-user text-cyan-600"></i>
                      <span>My Profile</span>
                    </Link>
                    {/* <Link
                      to="/my-orders"
                      className="w-full flex items-center space-x-3 px-4 py-3 text-left hover:bg-gray-50 rounded-xl transition-colors text-gray-700"
                      onClick={() => setShowProfileMenu(false)}
                    >
                      <i className="fa-solid fa-shopping-bag text-blue-600"></i>
                      <span>My Orders</span>
                      {hasNewOrders && (
                        <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                      )}
                    </Link> */}
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center space-x-3 px-4 py-3 text-left hover:bg-red-50 rounded-xl transition-colors text-red-600"
                    >
                      <i className="fa-solid fa-sign-out-alt"></i>
                      <span> Logout </span>
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center space-x-2">
                <Link
                  to="https://iblotecmarket.com/"
                  className="hidden sm:inline px-20 border border-black rounded-full bg-white py-2 text-gray-700 hover:scale-105 font-semibold transition-transform"
                >
                  Login
                </Link>

                <Link
                  to="https://iblotecmarket.com/"
                  className="px-10 md:px-20 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-full font-semibold hover:scale-105 transition-transform"
                >
                  Register
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Notifications */}
      <div className="notifications">
        {notifications.map((note) => (
          <div
            key={note.id}
            className="notification"
            onClick={() => removeNotification(note.id)}
          >
            {note.message}
          </div>
        ))}
      </div>

      {/* Mobile Menu Drawer */}
      {mobileMenuOpen && (
        <div className="mobile-menu-drawer">
          <div className="drawer-header">
            <button className="close-drawer" onClick={toggleMobileMenu}>
              <i className="fa-solid fa-times"></i>
            </button>
            <h3>Menu</h3>
          </div>
          <div className="drawer-content">
            {/* <Link
              to="/school"
              className={`drawer-item ${isActive("/school") ? "active" : ""}`}
              onClick={toggleMobileMenu}
            >
              <i className="fa-solid fa-graduation-cap"></i>
              <span>School</span>
            </Link> */}
            {/* <Link
              to="/houses"
              className={`drawer-item ${isActive("/houses") ? "active" : ""}`}
              onClick={toggleMobileMenu}
            >
              <i className="fa-solid fa-house"></i>
              <span>Houses</span>
            </Link> */}
            {/* <Link
              to="/cars"
              className={`drawer-item ${isActive("/cars") ? "active" : ""}`}
              onClick={toggleMobileMenu}
            >
              <i className="fa-solid fa-car"></i>
              <span>Cars</span>
            </Link> */}
            {/* <Link
              to="/services"
              className={`drawer-item ${isActive("/services") ? "active" : ""}`}
              onClick={toggleMobileMenu}
            >
              <i className="fa-solid fa-wrench"></i>
              <span>Services</span>
            </Link> */}
            <Link
              to="/home"
              className={`drawer-item ${isActive("/home") ? "active" : ""}`}
              onClick={toggleMobileMenu}
            >
              <i className="fa-solid fa-info-circle"></i>
              <span>About Us</span>
            </Link>
            <a
              href="https://api.whatsapp.com/send?phone=+25769316827&text=Hello"
              className="drawer-item"
              target="_blank"
              rel="noopener noreferrer"
              onClick={toggleMobileMenu}
            >
              <i className="fa-brands fa-whatsapp"></i>
              <span>Contact Us</span>
            </a>
          </div>
        </div>
      )}

      {/* Mobile App Bottom Navigation */}
      <div className="mobile-bottom-nav">
        <Link
          to="/home"
          className={`bottom-nav-item ${isActive("/home") ? "active" : ""}`}
        >
          <div className="bottom-nav-icon">
            <i className="fa-solid fa-home"></i>
          </div>
          <span>Home</span>
        </Link>
        <Link
          to="https://iblotecmarket.com/"
          className={`bottom-nav-item ${isActive("/market") ? "active" : ""}`}
        >
          <div className="bottom-nav-icon">
            <i className="fa-solid fa-store"></i>
          </div>
          <span>Market</span>
        </Link>
        {/* <Link
          to="/my-orders"
          className={`bottom-nav-item ${
            isActive("/my-orders") ? "active" : ""
          }`}
        >
          <div className="bottom-nav-icon">
            <i className="fa-solid fa-clipboard-list"></i>
            {hasNewOrders && <span className="notification-badge"></span>}
          </div>
          <span>Orders</span>
        </Link> */}
        <div
          className={`bottom-nav-item ${mobileMenuOpen ? "active" : ""}`}
          onClick={toggleMobileMenu}
        >
          <div className="bottom-nav-icon">
            <i className="fa-solid fa-bars"></i>
          </div>
          <span>Menu</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  navRight: {
    display: "flex",
    alignItems: "center",
  },
  profileSection: {
    position: "relative",
  },
  profileTrigger: {
    cursor: "pointer",
  },
  profilePicture: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid rgba(0, 166, 216)",
  },
  profileMenu: {
    position: "absolute",
    top: "100%",
    right: 0,
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    borderRadius: "4px",
    padding: "0.5rem",
    marginTop: "0.5rem",
    zIndex: 1000,
  },
  menuItem: {
    display: "block",
    padding: "0.5rem 1rem",
    textDecoration: "none",
    color: "#333",
    transition: "background-color 0.3s ease",
  },
  logoutButton: {
    width: "100%",
    padding: "0.5rem 1rem",
    border: "none",
    backgroundColor: "#dc3545",
    color: "#fff",
    cursor: "pointer",
    borderRadius: "4px",
    marginTop: "0.5rem",
  },
  authButtons: {
    display: "flex",
    gap: "1rem",
  },
  authButton: {
    padding: "0.5rem 1rem",
    textDecoration: "none",
    color: "#fff",
    backgroundColor: "#007bff",
    borderRadius: "4px",
    transition: "background-color 0.3s ease",
  },
};

export default Navbar;
